




import {Vue, Component} from 'vue-property-decorator'

import ConfigService  from '@/components/ConfigService.vue'

@Component({
  components: {
      ConfigService
  }
})
export default class ConfigServiceView extends Vue {
}
